//Cart Page Offer
var cart_modal = document.getElementById("cart-offer-modal");
var cart_btn = document.getElementById("cart-offer-btn");
var cart_span = document.querySelector(".cart-offer-modal-close");

cart_btn.onclick = function(a) {
  a.preventDefault();
  cart_modal.classList.add("open");
}

cart_span.onclick = function() {
  cart_modal.classList.remove("open");
}

window.onclick = function(event) {
  if (event.target == cart_modal) {
    cart_modal.classList.remove("open");
  }
}

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};


var form_success = getUrlParameter('contact_posted');
var success_offer_modal = document.getElementById("success-offer-modal");
var success_offer_span = document.querySelector(".success-offer-modal-close");
  
success_offer_span.onclick = function() {
	success_offer_modal.classList.remove("open");
}

window.onclick = function(event) {
  if (event.target == success_offer_modal) {
    success_offer_modal.classList.remove("open");
  }
}

if (form_success == 'true') {   
  	success_offer_modal.classList.add("open");
  	window.history.replaceState({}, document.title, "/" + "cart");
}